module.exports = __webpack_public_path__ + "img/panels-inactive.96be8767.svg";